import React, {Component} from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Navigation from '../Navigation';
import LandingPage from '../Landing';
import SignUpPage from '../SignUp';
import SignInPage from '../SignIn';
import PasswordForgetPage from '../PasswordForget';
import AdminPage from '../Admin/AdminPage';
import * as ROUTES from '../../constants/routes';
import {reactLocalStorage} from 'reactjs-localstorage';
import AccountPage from "../Account";
import JobHistory from "../JobHistory";
import Login from "../Login/Login";
import DisableWorker from "../Admin/DisableWorker";
import Otp from "../Otp";
import ConfirmPassword from "../PasswordChange/ConfirmPassword";
import Home from "../Home";
import Error from "../Error/Error";
import AllJobs from "../AllJobs/AllJobs";
import AdminLogin from "../Admin/AdminLogin";
import {Elements, ElementsConsumer} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import CheckoutForm from "../stripe/CheckoutForm";
import Commission from "../Commission/Commission";
import Fund from "../Fund/Fund";





class App extends Component {
    FirebaseContext = React.createContext('');
    stripePromise = loadStripe('pk_live_7KyzOS0C5JC1UTMfIm2R197o003EeJFcu0');



    constructor(props) {
        super(props);
        this.state = { user: JSON.parse(localStorage.getItem('user'))
                ? JSON.parse(localStorage.getItem('user'))
                : '',
            userId:JSON.parse(localStorage.getItem('userIds'))
                ? JSON.parse(localStorage.getItem('userIds'))
                : ''
        , error: ""}
        this.updateNewUser = this.updateNewUser.bind(this)
        this.removeUser = this.removeUser.bind(this)
        this.setError = this.setError.bind(this)
        this.updateOtpInfo = this.updateOtpInfo.bind(this)
        this.updateNewUserId = this.updateNewUserId.bind(this)
    }

    setError(error){
        this.setState({error: error})
    }



    updateNewUser(newUser){
        // console.log(newUser)
        this.setState({ user: newUser})
        reactLocalStorage.setObject('user', newUser);
        this.setState({ userId:{
            "docId": newUser.userId,
                "phone": newUser.phone,
                "type": newUser.type
        }})
        reactLocalStorage.setObject('userIds',{
                "docId": newUser.userId,
                "phone": newUser.phone,
                "type": newUser.type
            }
        );

    }
    updateNewUserId(newUser){
        console.log(newUser)
        this.setState({ userId: newUser})
        reactLocalStorage.setObject('userIds', newUser);

    }

    removeUser(){
        console.log("removed")
        this.setState({ user: ''})
        this.setState({ userId: ''})
        reactLocalStorage.remove('user');
        reactLocalStorage.remove('userIds');
    }

    updateOtpInfo(newUser){
        this.setState({ userId:{
                "docId": newUser.docId,
                "type": newUser.type
            }})
        reactLocalStorage.setObject('userIds',{
                "docId": newUser.docId,
                "type": newUser.type
            }
        );
    }


    render() {
        return (
            <this.FirebaseContext.Provider value={ this.state.user}>

            <Router>
                <div>
                        <Route path={ROUTES.OTP} render={ (props)=> <Otp {...props} user={this.state.user} updateOtpInfo={this.updateOtpInfo}/>} />
                        <Route path={ROUTES.LOGIN} render={ (props)=> <Login {...props} user={this.state.user} removeUser={this.removeUser} updateNewUser={this.updateNewUser}/>} />
                        <Route path={ROUTES.ADMIN_LOGIN} render={ (props)=> <AdminLogin {...props} user={this.state.user} removeUser={this.removeUser} updateNewUser={this.updateNewUser}/>} />
                        <Route render={ (props)=> <Navigation {...props} user={this.state.user} removeUser={this.removeUser}/>} />
                        {/*<Navigation user={this.state.user} removeUser={this.removeUser} />*/}
                        <div className={ this.state.user? "content-wrapper": ""} >
                            <Route path={ROUTES.ERROR} render={ (props)=> <Error {...props} user={this.state.user} error={this.state.error} updateNewUser={this.updateNewUser}/>} />
                            <Route exact path={ROUTES.LANDING} component={LandingPage} />
                            <Route path={ROUTES.DISABLE_WORKER} render={ (props)=> <DisableWorker {...props} user={this.state.user} setError={this.setError} updateNewUser={this.updateNewUser}/>} />
                            <Route path={ROUTES.ALL_JOBS} render={ (props)=> <AllJobs {...props} user={this.state.user} setError={this.setError} updateNewUser={this.updateNewUser}/>} />

                            {/*<Route exact path={"/workerActions"} component={DisableWorker} setError={this.setError}/>*/}
                            <Route path={ROUTES.SIGN_UP} render={ (props)=> <SignUpPage {...props} user={this.state.user} removeUser={this.removeUser}/>} />
                            <Route path={ROUTES.SIGN_IN} render={ (props)=> <SignInPage {...props} user={this.state.user} updateNewUser={this.updateNewUser}/>} />
                            <Route
                                path={ROUTES.PASSWORD_FORGET}
                                component={PasswordForgetPage}
                            />
                            <Route path={ROUTES.PASSWORD_CONFIRM} render={ (props)=> <ConfirmPassword {...props} user={this.state.user} updateNewUser={this.updateNewUser}
                                                                                                      userId={this.state.userId} />} />

                            <Route path={ROUTES.HOME} render={ (props)=> <Home {...props} user={this.state.user} removeUser={this.removeUser} language={this.state.user.language}/>} />
                            <Route exact path={ROUTES.LANDING} render={ (props)=> <Home {...props} user={this.state.user} removeUser={this.removeUser}/>} />
                            <Route path="/jh" render={(props)=> <JobHistory {...props} user={this.state.user}  />}/>
                            <Route path={ROUTES.ACCOUNT} render={ (props)=> <AccountPage {...props} user={this.state.user} removeUser={this.removeUser}/>} />
                            <Route path={ROUTES.ADMIN} render={ (props)=> <AdminPage {...props} user={this.state.user} removeUser={this.removeUser}/>} />

                            <Elements stripe={this.stripePromise}>
                                <ElementsConsumer>
                                    {({elements, stripe}) => (
                                        <Route path={ROUTES.FUNDED} render={ (props)=> <Fund {...props} user={this.state.user} removeUser={this.removeUser} stripe={stripe}  elements={elements}/>} />

                                        // <Route path="/commission" render={ (props)=> <Commission {...props} user={this.state.user} removeUser={this.removeUser} stripe={stripe}  elements={elements}/>}/>

                                    )}
                                </ElementsConsumer>

                            </Elements>

                            <Elements stripe={this.stripePromise}>
                                <ElementsConsumer>
                                    {({elements, stripe}) => (
                                        <Route path={ROUTES.PAY} render={(props)=><CheckoutForm {...props} user={this.state.user} removeUser={this.removeUser} stripe={stripe}  elements={elements}/>}/>

                                        // <Route path="/commission" render={ (props)=> <Commission {...props} user={this.state.user} removeUser={this.removeUser} stripe={stripe}  elements={elements}/>}/>

                                        )}
                                </ElementsConsumer>

                            </Elements>




                        </div>







                </div>
                {/*<Route  path={"*"}  component={Error} />*/}

            </Router>
             </this.FirebaseContext.Provider>

        );
    }
}

export default App;